/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_Lock_DescInputs */

const en_landing_why_lock_desc = /** @type {(inputs: Landing_Why_Lock_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After a masked edit, unpainted pixels are copied back from your source. Exact, not approximate.`)
};

const zh_landing_why_lock_desc = /** @type {(inputs: Landing_Why_Lock_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遮罩编辑后，未涂抹像素从原图拷回。是精确一致，而非近似。`)
};

/**
* | output |
* | --- |
* | "After a masked edit, unpainted pixels are copied back from your source. Exact, not approximate." |
*
* @param {Landing_Why_Lock_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_lock_desc = /** @type {((inputs?: Landing_Why_Lock_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_Lock_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_lock_desc(inputs)
	return zh_landing_why_lock_desc(inputs)
});
export { landing_why_lock_desc as "landing.why.lock_desc" }